import { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { WorkflowType, Workflow } from '../types';
import { selectAllSendActivity } from '../selectors';
import { fetchSendActivity } from '../actions';

type WorkflowData = Pick<Workflow, 'id' | 'workflowType'>;

/**
 * Ensures that send activity is loaded into the Redux store for all passed workflows.
 */
export const useSendActivityForWorkflows = (workflows: WorkflowData[]) => {
  const dispatch = useDispatch();
  const cachedSendActivity = useSelector(selectAllSendActivity);
  const workflowIdsToLoad = useMemo(
    () =>
      workflows.reduce((acc: number[], curr: WorkflowData) => {
        if (
          curr.workflowType === WorkflowType.PUBLISHED &&
          cachedSendActivity?.[curr.id] === undefined
        ) {
          acc.push(curr.id);
        }
        return acc;
      }, [] as number[]),
    [workflows, cachedSendActivity],
  );
  const workflowIdsHash = useMemo(() => workflowIdsToLoad.join('-'), [workflowIdsToLoad]);

  useEffect(() => {
    if (workflowIdsToLoad.length) {
      dispatch(fetchSendActivity(workflowIdsToLoad));
    }
  }, [workflowIdsHash]);
};
